import { IResponse } from "../contracts/IResponse";
import { HttpMethodEnum } from "../enums/enums";
import { Claim } from "../models/Claim";
import { Order } from "../models/Order";
import { SignInModel } from "../models/SignInModel";
import { BaseService } from "./BaseService";

export class OrderService extends BaseService {
    constructor() {
        super("order")
    }

    Create(model: Order): Promise<IResponse<number>> {
        return fetch(`${this.EndPoint}/create`, { method: HttpMethodEnum.POST, body: JSON.stringify(model), headers:{ "Content-Type": "application/json" }}).then(response => response.json())
    }
}